"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("react");

function r(t) {
  return t && "object" == typeof t && "default" in t ? t : {
    default: t
  };
}

var n = r(require("cancelable-promise")),
    _e = function e() {
  return (_e = Object.assign || function (t) {
    for (var r, n = 1, e = arguments.length; n < e; n++) {
      for (var u in r = arguments[n]) {
        Object.prototype.hasOwnProperty.call(r, u) && (t[u] = r[u]);
      }
    }

    return t;
  }).apply(this, arguments);
},
    u = function u() {
  return null;
},
    o = function o(r, n) {
  var e,
      o,
      i = t.useState(r),
      a = i[0],
      c = i[1],
      f = t.useRef(null !== (e = n.value) && void 0 !== e ? e : r);
  f.current = null !== (o = n.value) && void 0 !== o ? o : r;
  var l = t.useCallback(function (t) {
    var r;
    return (null !== (r = n.onChange) && void 0 !== r ? r : u)("function" == typeof t ? t(f.current) : t);
  }, [n.onChange]);
  return null != n.value || null != n.onChange ? [f.current, l] : [a, c];
},
    i = function i(t) {
  return t.filter(function (t) {
    return null != t;
  });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


function a(t) {
  return null != t && "object" == typeof t && !0 === t["@@functional/placeholder"];
}

function c(t) {
  return function r(n) {
    return 0 === arguments.length || a(n) ? r : t.apply(this, arguments);
  };
}

function f(t) {
  return function r(n, e) {
    switch (arguments.length) {
      case 0:
        return r;

      case 1:
        return a(n) ? r : c(function (r) {
          return t(n, r);
        });

      default:
        return a(n) && a(e) ? r : a(n) ? c(function (r) {
          return t(r, e);
        }) : a(e) ? c(function (r) {
          return t(n, r);
        }) : t(n, e);
    }
  };
}

function l(t, r) {
  switch (t) {
    case 0:
      return function () {
        return r.apply(this, arguments);
      };

    case 1:
      return function (t) {
        return r.apply(this, arguments);
      };

    case 2:
      return function (t, n) {
        return r.apply(this, arguments);
      };

    case 3:
      return function (t, n, e) {
        return r.apply(this, arguments);
      };

    case 4:
      return function (t, n, e, u) {
        return r.apply(this, arguments);
      };

    case 5:
      return function (t, n, e, u, o) {
        return r.apply(this, arguments);
      };

    case 6:
      return function (t, n, e, u, o, i) {
        return r.apply(this, arguments);
      };

    case 7:
      return function (t, n, e, u, o, i, a) {
        return r.apply(this, arguments);
      };

    case 8:
      return function (t, n, e, u, o, i, a, c) {
        return r.apply(this, arguments);
      };

    case 9:
      return function (t, n, e, u, o, i, a, c, f) {
        return r.apply(this, arguments);
      };

    case 10:
      return function (t, n, e, u, o, i, a, c, f, l) {
        return r.apply(this, arguments);
      };

    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}

function s(t, r, n) {
  return function () {
    for (var e = [], u = 0, o = t, i = 0; i < r.length || u < arguments.length;) {
      var c;
      i < r.length && (!a(r[i]) || u >= arguments.length) ? c = r[i] : (c = arguments[u], u += 1), e[i] = c, a(c) || (o -= 1), i += 1;
    }

    return o <= 0 ? n.apply(this, e) : l(o, s(t, e, n));
  };
}

var p = f(function (t, r) {
  return 1 === t ? c(r) : l(t, s(t, [], r));
}),
    h = Array.isArray || function (t) {
  return null != t && t.length >= 0 && "[object Array]" === Object.prototype.toString.call(t);
};

function y(t) {
  return null != t && "function" == typeof t["@@transducer/step"];
}

function d(t, r, n) {
  return function () {
    if (0 === arguments.length) return n();
    var e = Array.prototype.slice.call(arguments, 0),
        u = e.pop();

    if (!h(u)) {
      for (var o = 0; o < t.length;) {
        if ("function" == typeof u[t[o]]) return u[t[o]].apply(u, e);
        o += 1;
      }

      if (y(u)) {
        var i = r.apply(null, e);
        return i(u);
      }
    }

    return n.apply(this, arguments);
  };
}

var g = function g() {
  return this.xf["@@transducer/init"]();
},
    v = function v(t) {
  return this.xf["@@transducer/result"](t);
};

function m(t) {
  return "[object String]" === Object.prototype.toString.call(t);
}

var b = c(function (t) {
  return !!h(t) || !!t && "object" == typeof t && !m(t) && (1 === t.nodeType ? !!t.length : 0 === t.length || t.length > 0 && t.hasOwnProperty(0) && t.hasOwnProperty(t.length - 1));
}),
    x = function () {
  function t(t) {
    this.f = t;
  }

  return t.prototype["@@transducer/init"] = function () {
    throw new Error("init not implemented on XWrap");
  }, t.prototype["@@transducer/result"] = function (t) {
    return t;
  }, t.prototype["@@transducer/step"] = function (t, r) {
    return this.f(t, r);
  }, t;
}();

var j = f(function (t, r) {
  return l(t.length, function () {
    return t.apply(r, arguments);
  });
});

function O(t, r, n) {
  for (var e = n.next(); !e.done;) {
    if ((r = t["@@transducer/step"](r, e.value)) && r["@@transducer/reduced"]) {
      r = r["@@transducer/value"];
      break;
    }

    e = n.next();
  }

  return t["@@transducer/result"](r);
}

function w(t, r, n, e) {
  return t["@@transducer/result"](n[e](j(t["@@transducer/step"], t), r));
}

var S = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";

function I(t, r, n) {
  if ("function" == typeof t && (t = function (t) {
    return new x(t);
  }(t)), b(n)) return function (t, r, n) {
    for (var e = 0, u = n.length; e < u;) {
      if ((r = t["@@transducer/step"](r, n[e])) && r["@@transducer/reduced"]) {
        r = r["@@transducer/value"];
        break;
      }

      e += 1;
    }

    return t["@@transducer/result"](r);
  }(t, r, n);
  if ("function" == typeof n["fantasy-land/reduce"]) return w(t, r, n, "fantasy-land/reduce");
  if (null != n[S]) return O(t, r, n[S]());
  if ("function" == typeof n.next) return O(t, r, n);
  if ("function" == typeof n.reduce) return w(t, r, n, "reduce");
  throw new TypeError("reduce: list must be array or iterable");
}

var A = function () {
  function t(t, r) {
    this.xf = r, this.f = t;
  }

  return t.prototype["@@transducer/init"] = g, t.prototype["@@transducer/result"] = v, t.prototype["@@transducer/step"] = function (t, r) {
    return this.xf["@@transducer/step"](t, this.f(r));
  }, t;
}(),
    E = f(function (t, r) {
  return new A(t, r);
});

function F(t, r) {
  return Object.prototype.hasOwnProperty.call(r, t);
}

var P = Object.prototype.toString,
    M = function () {
  return "[object Arguments]" === P.call(arguments) ? function (t) {
    return "[object Arguments]" === P.call(t);
  } : function (t) {
    return F("callee", t);
  };
}(),
    k = !{
  toString: null
}.propertyIsEnumerable("toString"),
    C = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
    D = function () {
  return arguments.propertyIsEnumerable("length");
}(),
    N = function N(t, r) {
  for (var n = 0; n < t.length;) {
    if (t[n] === r) return !0;
    n += 1;
  }

  return !1;
},
    T = "function" != typeof Object.keys || D ? c(function (t) {
  if (Object(t) !== t) return [];
  var r,
      n,
      e = [],
      u = D && M(t);

  for (r in t) {
    !F(r, t) || u && "length" === r || (e[e.length] = r);
  }

  if (k) for (n = C.length - 1; n >= 0;) {
    F(r = C[n], t) && !N(e, r) && (e[e.length] = r), n -= 1;
  }
  return e;
}) : c(function (t) {
  return Object(t) !== t ? [] : Object.keys(t);
}),
    q = f(d(["fantasy-land/map", "map"], E, function (t, r) {
  switch (Object.prototype.toString.call(r)) {
    case "[object Function]":
      return p(r.length, function () {
        return t.call(this, r.apply(this, arguments));
      });

    case "[object Object]":
      return I(function (n, e) {
        return n[e] = t(r[e]), n;
      }, {}, T(r));

    default:
      return function (t, r) {
        for (var n = 0, e = r.length, u = Array(e); n < e;) {
          u[n] = t(r[n]), n += 1;
        }

        return u;
      }(t, r);
  }
})),
    _ = Number.isInteger || function (t) {
  return t << 0 === t;
},
    L = f(function (t, r) {
  var n = t < 0 ? r.length + t : t;
  return m(r) ? r.charAt(n) : r[n];
}),
    K = f(function (t, r) {
  return t.map(function (t) {
    for (var n, e = r, u = 0; u < t.length;) {
      if (null == e) return;
      n = t[u], e = _(n) ? L(n, e) : e[n], u += 1;
    }

    return e;
  });
}),
    R = f(function (t, r) {
  return K([t], r)[0];
}),
    W = c(function (t) {
  return p(t.length, t);
});

function X(t) {
  return t;
}

var z = c(X);

function B(t) {
  return [t];
}

var G = c(B),
    H = f(function (t, r) {
  return p(r.length, function () {
    for (var n = [], e = 0; e < r.length;) {
      n.push(r[e].call(this, arguments[e])), e += 1;
    }

    return t.apply(this, n.concat(Array.prototype.slice.call(arguments, r.length)));
  });
}),
    J = f(function (t, r) {
  for (var n, e = 0, u = t.length, o = r.length, i = []; e < u;) {
    for (n = 0; n < o;) {
      i[i.length] = [t[e], r[n]], n += 1;
    }

    e += 1;
  }

  return i;
}),
    Q = f(function (t, r) {
  for (var n = 0, e = Math.min(t.length, r.length), u = {}; n < e;) {
    u[t[n]] = r[n], n += 1;
  }

  return u;
}),
    U = W(function (t, r) {
  return Q(r, q(t, r));
}),
    V = W(function (t, r) {
  if (r.length <= t) return r.slice();
  var n = t - 3,
      e = r.substr(0, n);
  return (e = e.substr(0, Math.min(e.length, e.lastIndexOf(" ")))) + "...";
}),
    Y = H(J, [G, z]),
    Z = function Z(t) {
  return new n.default(function (r, n) {
    var e = new Image();
    e.onload = r, e.onerror = n, e.src = t;
  });
};

exports.countLabelFormatter = function (t, r, n, e) {
  return function (u) {
    return u < 1 ? t : u % 100 > 10 && u % 100 < 15 ? e(u) : 1 === u ? r : u % 10 > 1 && u % 10 < 5 ? n(u) : e(u);
  };
}, exports.formDataFromObj = function (t) {
  var r = new FormData();
  return T(t).forEach(function (n) {
    return r.append("" + n, t[n]);
  }), r;
}, exports.formatNumber = function (t, r) {
  var n, u, o;
  return void 0 === r && (r = {}), "" + (null !== (n = r.prefix) && void 0 !== n ? n : "") + Intl.NumberFormat(r.locale, _e({
    maximumFractionDigits: null !== (u = r.maximumFractionDigits) && void 0 !== u ? u : 2
  }, r)).format(t) + (null !== (o = r.suffix) && void 0 !== o ? o : "");
}, exports.mergeClassName = function (t, r) {
  return r ? t + " " + r : t;
}, exports.noop = u, exports.objFromKeys = U, exports.preloadImage = Z, exports.preloadImages = function () {
  for (var t = [], r = 0; r < arguments.length; r++) {
    t[r] = arguments[r];
  }

  return Promise.all(i(t).map(Z));
}, exports.prune = i, exports.randomElement = function (t) {
  return function () {
    return t[Math.floor(Math.random() * t.length)];
  };
}, exports.setClearableTimeout = function (t, r, n, e) {
  e[n] = setTimeout(function () {
    t(), delete e[n];
  }, r);
}, exports.shuffle = function (t) {
  return function () {
    for (var r, n = t.slice(), e = n.length - 1; e > 0; e--) {
      var u = Math.floor(Math.random() * (e + 1));
      r = [n[u], n[e]], n[e] = r[0], n[u] = r[1];
    }

    return n;
  };
}, exports.styledIs = function (t) {
  return function (r) {
    return function (n) {
      return !!R(t.split("."), n) && r;
    };
  };
}, exports.triStateMapper = function (t, r, n) {
  return function (e) {
    if (!0 === e) return t;
    if (!1 === e) return r;
    if (null === e) return n;
    throw new Error("Invalid value passed to triState!");
  };
}, exports.truncate = V, exports.useDerivedState = o, exports.xPairs = Y, exports.yiq = function (t, r) {
  var n,
      e,
      u = null !== (n = null == r ? void 0 : r.light) && void 0 !== n ? n : "#ffffff",
      o = null !== (e = null == r ? void 0 : r.dark) && void 0 !== e ? e : "#000000";
  return (299 * parseInt(t.substr(1, 2), 16) + 587 * parseInt(t.substr(3, 2), 16) + 114 * parseInt(t.substr(5, 2), 16)) / 1e3 < 128 ? u : o;
};